module.exports = __webpack_public_path__ + "img/visuooh.71ac8b31.jpeg";